import React from 'react';
import classNames from 'classnames';
import { isEmail } from 'validator';

import styles from '../AuthPage.module.scss';

import { Input } from '@components/Input';
import { SaveButton } from '@components/ActionButtons/SaveButton';
import { GoogleButton } from '@components/ActionButtons/GoogleButton';
import { translate } from '@chaika/i18n/helper';
import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';

interface LoginFormProps {
    email: string;
    password: string;
    userErrorMessage?: string;
    passwordErrorMessage?: string;
    onInputChange(e: React.ChangeEvent<HTMLInputElement>): void;
    onLoginClick(): void;
    onRecoveryClick(): void;
}

export function LoginForm({
    email,
    password,
    userErrorMessage,
    passwordErrorMessage,
    onInputChange,
    onLoginClick,
    onRecoveryClick,
}: LoginFormProps) {
    function onGoogleButtonClick() {
        const newUrl = new URL(window.location.href);
        newUrl.pathname = 'api/auth/google';

        window.location.href = newUrl.toString();
    }

    return (
        <>
            <div className={classNames([styles.fieldWrapper, !!userErrorMessage && styles.smallMargin])}>
                <Input
                    name={'email'}
                    title={'E-mail'}
                    value={email}
                    autoComplete={'on'}
                    showValidStatus
                    isValid={userErrorMessage ? false : undefined}
                    onChange={onInputChange}
                    onKeyDown={e => (e.key === 'Enter' ? onLoginClick() : null)}
                />
                {!!userErrorMessage && <span className={styles.errorMessage}>{userErrorMessage}</span>}
            </div>
            <div className={classNames([styles.fieldWrapper, !!passwordErrorMessage && styles.smallMargin])}>
                <Input
                    type={'password'}
                    name={'password'}
                    title={translate('password')}
                    autoComplete={'current-password'}
                    value={password}
                    showValidStatus
                    isValid={passwordErrorMessage ? false : undefined}
                    onChange={onInputChange}
                    onKeyDown={e => (e.key === 'Enter' ? onLoginClick() : null)}
                />
                {!!passwordErrorMessage && <span className={styles.errorMessage}>{passwordErrorMessage}</span>}
            </div>
            <div className={classNames([styles.fieldWrapper, styles.smallMargin])}>
                <SaveButton
                    modifiers={[ButtonModifiers.InheritWidth]}
                    label={translate('signIn')}
                    onSaveClick={onLoginClick}
                />
            </div>
            <div className={classNames([styles.fieldWrapper, styles.bigMargin])}>
                <Button
                    disabled={!isEmail(email)}
                    theme={ButtonTheme.Secondary}
                    modifiers={[ButtonModifiers.InheritWidth]}
                    label={translate('restorePassword')}
                    onClick={onRecoveryClick}
                />
            </div>
            <div className={styles.fieldWrapper}>
                <GoogleButton
                    label={translate('signInWithGoogle')}
                    onClick={onGoogleButtonClick}
                />
            </div>
        </>
    );
}
